import { useState, useEffect, useRef } from "react";
import { FaSearch, FaTimes } from "react-icons/fa";

const CommonFilter = ({ config, onApply }) => {
    const [filters, setFilters] = useState({});
    const [searchValue, setSearchValue] = useState("");
    const isFirstRender = useRef(true);

    const handleChange = (name, value) => {
        const updated = { ...filters, [name]: value };
        setFilters(updated);
        onApply(updated);
    };

    const handleClear = () => {
        const cleared = {};
        setFilters(cleared);
        setSearchValue("");
        onApply(cleared);
    };

    const hasFiltersApplied = Object.values(filters).some(
        (val) => val && (Array.isArray(val) ? val.length > 0 : val !== "")
    );

   useEffect(() => {
    if (isFirstRender.current) {
        isFirstRender.current = false;
        return;
    }

    const delay = setTimeout(() => {
        if (searchValue !== filters[config?.[0]?.name]) {
            handleChange(config?.[0]?.name, searchValue);
        }
    }, 500);

    return () => clearTimeout(delay);
}, [searchValue]);


    return (
        <div className="flex flex-col md:flex-row md:items-center md:justify-between w-full pb-3 mb-1 gap-3">
            <div className="flex flex-wrap items-center gap-3">
                <div className="relative">
                    <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                    <input
                        type="text"
                        placeholder={config?.[0]?.placeholder}
                        className="pl-10 pr-3 py-1 w-full md:w-64 rounded-md border border-gray-300 bg-gray-50 focus:outline-none focus:ring-1 focus:ring-gray-400"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                    />
                </div>

                {config.map((field) => {
                    if (field.type === "select") {
                        return (
                            <select
                                key={field.name}
                                className="px-2 py-1 border border-gray-300 rounded-md bg-white w-full md:w-auto min-w-[170px] focus:outline-none text-black custom-select"
                                value={filters[field.name] || ""}
                                onChange={(e) => handleChange(field.name, e.target.value)}
                            >
                                <option value="">{field.label}</option>
                                {field.options.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </option>
                                ))}
                            </select>
                        );
                    }
                    return null;
                })}
            </div>

            {hasFiltersApplied && (
                <button
                    onClick={handleClear}
                    className="px-3 py-1 text-sm bg-red-100 text-red-600 border border-red-300 rounded-md hover:bg-red-200 flex items-center justify-center gap-2 w-full md:w-auto"
                >
                    <FaTimes size={12} />
                    Clear Filters
                </button>
            )}
        </div>
    );
};

export default CommonFilter;
